import React, { useMemo } from "react";
import AreaChart from "../../components/Charts/AreaChart";
import { retentionAndChurnProps } from "../../components/Charts/ChartConfig";
import { MuiLoader } from "../../Utils/common";

const ChurnGraph = ({ name, dateRange, data, loading }) => {
  const renderChurnGraph = useMemo(() => {
    return {
      ...retentionAndChurnProps,
      ...data,
    };
  }, [data]);
  return (


    <div className="chart-parent">
      <div className="chat-infos">
        <h6> {name} </h6>
      </div>

      {loading ?
        <MuiLoader size={40} message="Fetching data...." />
        :
        <AreaChart showMarkers={true} showNameLabel={true} dateRange={dateRange} {...renderChurnGraph} chartType="line" />
      }



    </div>
  );
};

export default ChurnGraph;
